import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { AdminService } from "../../../services/admin-service";
import { PermissionService } from "../../../services/permission-service";

export const Usereditcontent = (props) => {
  const { adminID } = useParams();

  const [submitloading, setSubmitLoading] = useState(true);

  const [acclevel, setAccessLevel] = useState([]);

  const accessLevelSearch = async () => {
    try {
      const result = await PermissionService.accesslevelDetails();

      setAccessLevel(result);
    } catch (err) {
      //toast
    }
  };

  const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    try {
      await AdminService.adminUpdate(
        adminID,
        values.address,
        values.phone,
        values.nic,
        values.name,
        values.role
      );

      setSubmitLoading(true);
      notify("Admin successfully updated");
    } catch (err) {
      setSubmitLoading(true);
      //show error toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
        notifyWarning(err.response.data.message[0]);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  useEffect(() => {
    AdminSearchID();
    accessLevelSearch();
  }, []);

  const [admininfo, setAdminInfo] = useState({
    address: "",
    email: "",
    phone: "",
    nic: "",
    role: "",
    name: "",
  });

  const AdminSearchID = async () => {
    try {
      const result = await AdminService.adminDetailsID(adminID);

      const info = {};

      const admindata = result;

      info.address = admindata.admin.address;
      info.email = admindata.admin.email;
      info.phone = admindata.admin.phone;
      info.nic = admindata.admin.nic;
      info.role = admindata.admin.role;
      info.name = admindata.admin.name;

      setAdminInfo(info);
    } catch (err) {
      //toast
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Edit User</h6>
            </div>
            <div className="ms-panel-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  address: admininfo.address,
                  email: admininfo.email,
                  phone: admininfo.phone,
                  nic: admininfo.nic,
                  name: admininfo.name,
                  role: admininfo.role,
                }}
                validationSchema={Yup.object().shape({
                  address: Yup.string().required("Required"),
                  phone: Yup.string()
                    .required("Required")
                    .matches(phoneRegExp, "Phone number is not valid"),

                  nic: Yup.string()
                    .required("Required")
                    .min(10, "nic number must have at  10 characters"),

                  name: Yup.string().required("Required"),
                })}
                onSubmit={onSubmitForm}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  touched,
                  values,
                  submitForm,
                  isValid,
                }) => (
                  <div>
                    <div className="form-row">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom09">Name</label>
                        <div className="input-group">
                          <input
                            name="name"
                            type="text"
                            className="form-control"
                            id="nameid"
                            placeholder="Name"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.name && errors.name}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Email</label>
                        <div className="input-group">
                          <input
                            name="email"
                            type="email"
                            className="form-control"
                            id="emailid"
                            placeholder="Email"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            disabled
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.email && errors.email}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                          <label htmlFor="validationCustom08">Address</label>
                          <div className="input-group">
                            <input
                              name="address"
                              type="text"
                              className="form-control"
                              id="addressid"
                              placeholder="Address"
                              required
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.address}
                            />
                          </div>
                          <div style={{ color: "red", fontSize: "12px" }}>
                            {touched.address && errors.address}
                          </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Phone</label>
                        <div className="input-group">
                          <input
                            name="phone"
                            type="text"
                            className="form-control"
                            id="phoneid"
                            placeholder=""
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phone}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.phone && errors.phone}
                        </div>
                      </div>
                    </div>
                    <div className="form-row">
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom08">Nic</label>
                        <div className="input-group">
                          <input
                            name="nic"
                            type="text"
                            className="form-control"
                            id="nicid"
                            placeholder="NIC"
                            required
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.nic}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.nic && errors.nic}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label htmlFor="validationCustom09">Role</label>
                        <div className="input-group">
                          <div className="input-group">
                            <select
                              name="role"
                              className="form-control"
                              id="selectrole"
                              required
                              value={values.role}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            >
                              <option value="">Select</option>

                              {acclevel.map((item) => (
                                <option key={item.id} value={item.access_level}>
                                  {item.access_level}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {touched.role && errors.role}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-2" hidden={submitloading}>
                      <div className="spinner spinner-7">
                        <div className="bounce1" />
                        <div className="bounce2" />
                        <div className="bounce3" />
                      </div>
                    </div>
                    <div
                      className="form-row"
                      style={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        onClick={submitForm}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Usereditcontent;
